export const SHARED_TRACK_SUBFOLDER = 's';

export const PUBLIC_ROUTES = {
  root: `/${SHARED_TRACK_SUBFOLDER}`,
  sharedTrackBackwardCompatibility: `/${SHARED_TRACK_SUBFOLDER}/:sharedTrackId`,
  sharedTrack: `/${SHARED_TRACK_SUBFOLDER}/:genreKey/:templateKey/:sharedTrackId`,
};
